import { CardRowDetail, CardRowDetailColumn, CardRowDetailLine, CardRowDetailLineSpacer } from "widgets";
import styleSkeleton from "widgets/skeleton.module.css";

export const Skeleton = () => {
  return (
    <CardRowDetail>
      <CardRowDetailColumn>
        <CardRowDetailLine title="Name">
          <span className={styleSkeleton.skeleton}>Lorem ipsum dolor sit</span>
        </CardRowDetailLine>
        <CardRowDetailLineSpacer />
        <CardRowDetailLine title="Region">
          <span className={styleSkeleton.skeleton}>100000 - 200000</span>
        </CardRowDetailLine>
        <CardRowDetailLine title="Length">
          <span className={styleSkeleton.skeleton}>5000 bp</span>
        </CardRowDetailLine>
        <CardRowDetailLine title="Strand">
          <span className={styleSkeleton.skeleton}>+</span>
        </CardRowDetailLine>
      </CardRowDetailColumn>
    </CardRowDetail>
  );
};
